import { Box, Card, CardContent, Typography } from "@mui/material";
import React, { useState } from "react";

interface facultyCardProps {
    id: number;
    path: string;
    alt: string;
    imageText?: string;
    width?: string;
    height?: string;
    rowSpan?: number;
    columnSpan?: number;
    display: "flex" | "grid";
};

export interface GalleryImages {
    id: string;
    image: string;
    width?: string;
    height?: string;
}

export const GalleryCardComponent: React.FC<facultyCardProps> = ({ id, path, alt, imageText, width, height, rowSpan, columnSpan, display }) => {
    const [hover, setHover] = useState<boolean>(false);
    return (
        // Card for displaying image information
        <Card key={id}
            sx={{
                minWidth: 300, Width: "max-content", transition: "transform 0.3s ease-in-out",
                transform: hover ? "scale(1.15)" : "scale(1)",
                zIndex: hover ? "1" : "0",
                gridColumn: columnSpan ? `span ${columnSpan}` : null,
                gridRow: rowSpan ? `span ${rowSpan}`:null,
                boxShadow: hover ? 6 : 2
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {/* Image section */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    height: (display == "flex") ? height ? height : "300px" : "100%",
                    width: (display == "flex") ? width ? width : "300px" : "100%",
                    // width: "100%",
                    padding: "10px",
                }}

            >
                <Box component="img" src={path} height="100%" width="100%" alt={alt} sx={{ objectFit: 'fill', borderRadius: "5px 5px 0 0" }} />
            </Box>
            {/* Information Section */}
            {imageText &&
                < CardContent
                    sx={{
                        textAlign: "center",
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {imageText}
                    </Typography>
                </CardContent>
            }
        </Card >
    )
}